/**
 * Плюрализация существительного после числительного для русского языка.
 * @param count - число
 * @param forms - формы [1 просмотр, 2 просмотра, 5 просмотров]
 */
export const pluralizeRu = (
  count: number,
  forms: [one: string, few: string, many: string]
): string => {
  const lastDigit = count % 10;
  const lastTwoDigits = count % 100;

  // Исключение для чисел 11-14 (они всегда "many")
  if (lastTwoDigits >= 11 && lastTwoDigits <= 14) {
    return forms[2];
  }

  // 1, 21, 31, ... - "one"
  if (lastDigit === 1) {
    return forms[0];
  }

  // 2, 3, 4, 22, 23, 24, ... - "few"
  if (lastDigit >= 2 && lastDigit <= 4) {
    return forms[1];
  }

  // 0, 5-20, 25-30, ... - "many"
  return forms[2];
};
